/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BoothApplicationDto } from '../../models/booth-application-dto';
import { UpdateBoothApplicationDto } from '../../models/update-booth-application-dto';

export interface BoothApplicationControllerUpdateV1$Params {
  id: string;
      body: UpdateBoothApplicationDto
}

export function boothApplicationControllerUpdateV1(http: HttpClient, rootUrl: string, params: BoothApplicationControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothApplicationDto>> {
  const rb = new RequestBuilder(rootUrl, boothApplicationControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BoothApplicationDto>;
    })
  );
}

boothApplicationControllerUpdateV1.PATH = '/api/v1/booth-application/{id}';
